package meineglasfaser.frontend.admin.pages.shop

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

@Page
@Composable
fun ShopPage(ctx: PageContext) {
    // TODO
}
